/* eslint-disable camelcase */
/**
 * @param {import('@constructor-io/constructorio-client-javascript').AutocompleteResponse} response
 * @returns {import('custom-extensions/search/lib/api/types').SuggestResponse}
 */
export const transformSuggestResponse = response => {
	const sections = response?.sections || {};

	return {
		products: (sections.Products || []).map(item => {
			const data = item.data || {};

			return {
				id: data.id,
				image: data.image_url,
				name: item.value,
				product_url: data.url
			};
		}),
		terms: (sections['Search Suggestions'] || []).map(item => item.value)
	};
};
